import React from "react"
import Layout from "../../components/layout"
import SubNavigation from "../../components/sub-navigation"
import Hero from "../../components/hero"
import MemberVoices from "../../components/member-voices"
import ReadNext from "../../components/read-next"
import { AppendixWaypoint, Appendix } from "../../components/appendix"

const PAGESLUG = "economics"

export default function Economics() {
  return (
    <Layout>
      <SubNavigation id="A Crisis Like No Other" current={PAGESLUG} />
      <Hero
        bgColor="orange"
        bugColor="burnt-orange"
        image="spotlights/economics/hero.jpg"
      />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h1 className="page__title--opener">
              Government policies can help people adapt to big global changes
            </h1>
            <h2 className="page__title">Economics Shape People's Lives.</h2>
            <p>
              People all over the world are facing massive challenges and
              changes: the global pandemic, the effects of technology on work
              and wages, and rising inequality, to name a few. Governments will
              need policies to address these issues and support people so they
              can thrive and adapt to these developments.
            </p>

            <p>
              The IMF’s work recognizes that policy design affects people.
              Social spending can help economic reforms succeed by protecting
              the most vulnerable and addressing inequalities of opportunity and
              income. Such spending is also a key instrument to support
              inclusive growth through the 2030 Sustainable Development Goals.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={1} />
            <p>
              As inequality within countries grows and is exacerbated by the
              pandemic, entire communities and regions are being left behind.{" "}
              <a href="https://www.imf.org/en/Publications/WEO/Issues/2019/10/01/world-economic-outlook-october-2019#Chapter%202">
                IMF research
              </a>{" "}
              found that technology and the automation of jobs, rather than
              trade, are the main drivers of these disparities. Social spending
              on education to help workers gain new skills, or unemployment
              benefits to support them while they look for a new job, are
              necessary parts of the solution.
            </p>
            <h3 className="page__quote">
              as inequality within countries grows and is exacerbated by the
              pandemic,{" "}
              <em className="theme-color--burnt-orange">
                entire communities and regions are being left behind.
              </em>
            </h3>
            <AppendixWaypoint page={PAGESLUG} id={2} />
            <p>
              The IMF developed a strategy based on best practices for more
              effective engagement with countries on social spending issues. IMF
              surveillance and lending operations have increasingly emphasized
              inclusive growth and reducing inequality, including through the
              use of social spending “floors” as targets in IMF-supported
              programs. The Fund worked directly with country officials and gave
              technical assistance to help them make room in the budget for
              social spending. The IMF also provided training courses to tackle
              issues related to inclusive growth.
            </p>
          </div>
          <div className="container container--medium container--padding-v-none">
            <MemberVoices id="economics" />
          </div>
          <div className="container container--medium">
            <p>
              The Fund has seen that the proper sequencing of reforms in
              IMF-supported programs can also help in their success, and
              conditionality should be informed by a country’s political,
              social, and economic objectives.
            </p>
            <p>
              The fabric of any community is knitted together through shared
              values and experiences, and social spending helps bind that fabric
              together so that big changes are less likely to pull it apart.
            </p>
          </div>
        </div>
      </section>
      <Appendix page={PAGESLUG} />
      <ReadNext sectionID="spotlights" pageID="debt-dynamics" />
    </Layout>
  )
}
